import {
  initialState,
  Actions,
  State,
  GET_ALL_RESPONSIBLES_STATICS,
  GET_ALL_RESPONSIBLES_STATICS_SUCCESS,
  GET_ALL_RESPONSIBLES_STATICS_ERROR,
  RESET_GET_ALL_RESPONSIBLES_STATICS,
} from '../../types/statics/get-all-responsibles'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_RESPONSIBLES_STATICS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_RESPONSIBLES_STATICS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_RESPONSIBLES_STATICS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ALL_RESPONSIBLES_STATICS:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
